/* Banners to be shown in the home page */
import Banner_1 from "../assets/images/banners/banner1.png";
import Banner_2 from "../assets/images/banners/banner2.png";

export const HOME_BANNERS = [Banner_1, Banner_2];

export const FORM_MODES = {
	VIEW: "view",
	EDIT: "edit",
	ADD: "add",
};

export const SUBCATEGORIES = [
	{ label: "All", value: null },
	{ label: "Best Of", value: "best of" },
	{ label: "Charts", value: "charts" },
	{ label: "Essential", value: "essential" },
	{ label: "Featured", value: "featured" },
	{ label: "SE Podcast", value: "se podcast" },
	{ label: "International", value: "international" },
	{ label: "Misc", value: "misc" },
	{ label: "Priorities", value: "priorities" },
	{ label: "Sampled By", value: "sampled by" },
	{ label: "Staff & Guest Picks", value: "staff guest picks" },
];

// INFO: User Roles
export const roles = {
	USER: "USER",
};

export const revitionStatus = {
	ACTIVE: "ACTIVE",
	COMPLETED: "COMPLETED",
};

export const paymentHistoryTypes = {
	PAYMENT: "PAYMENT",
	PAYOUT: "PAYOUT",
};

// INFO: User Roles For Dropdown
export const rolesForDropdown = [
	{ label: "Client", id: "USER" },
	{ label: "Service Provider", id: "TASKER" },
];

export const firebaseUplaodFolders = {
	F_ID_IMAGES: "idimages",
	F_OFFERS: "offers",
	F_ORDERS: "orders",
	F_PROFILE_PICTURES: "profilepictures",
	F_COMPLAINTS: "complaints",
	F_ISSUES: "issues",
	F_MESSAGES: "messages",
	F_MESSAGES_ATTACHMENTS: "message_attachments",
	F_REFERENCES: "references",
	F_JOB_POSTS: "jobposts",
	F_ADDRESS_PROOF: "addressproof",
};

// INFO: order states
export const orderStatus = {
	ORDER_IN_PROGRESS: "ORDER_IN_PROGRESS",
	ORDER_DELIVERED: "ORDER_DELIVERED",
	IN_REVISION: "IN_REVISION",
	COMPLETED: "COMPLETED",
	COMPLAINT_RAISED: "COMPLAINT_RAISED",
	COMPLAINT_RESOLVED: "COMPLAINT_RESOLVED",
	ISSUE_RAISED: "ISSUE_RAISED",
	ISSUE_RESOLVED: "ISSUE_RESOLVED",
};

export const IGNORED_STATUSES = {
	USER: [orderStatus.ISSUE_RAISED, orderStatus.ISSUE_RESOLVED],
	TASKER: [orderStatus.COMPLAINT_RAISED, orderStatus.COMPLAINT_RESOLVED],
};

export const orderStatusDescription = {
	ORDER_IN_PROGRESS: {
		TASKER: "You are actively working on the assigned Job. Please deliver the completed Job once ready.",
		USER: "The Service Provider is actively working on the assigned task. Please wait for the next update.",
	},
	ORDER_DELIVERED: {
		TASKER: "The Job has been delivered. Wait for the client to review and accept or request a revision.",
		USER: "Service Provider has marked the task as delivered.",
	},
	IN_REVISION: {
		TASKER: "Revising the Job based on client feedback. Deliver the revised Job once done.",
		USER: "The Service Provider is revising the task based on your feedback.",
	},
	COMPLETED: {
		TASKER: "This Job has been successfully completed. Please leave a review or raise a complaint if necessary.",
		USER: "This Job has been successfully completed. Please leave a review or raise a complaint if necessary.",
	},
	COMPLAINT_RAISED: {
		TASKER: "A complaint has been raised for this task. The admin will address the issue shortly.",
		USER: "A complaint has been raised for this task. The admin will address the issue shortly.",
	},
	COMPLAINT_RESOLVED: {
		TASKER: "The complaint has been resolved. Thank you for your patience.",
		USER: "The complaint has been resolved. Thank you for your patience.",
	},
	ISSUE_RAISED: {
		TASKER: "A issue has been raised for this job. The admin will address the issue shortly.",
		USER: "A issue has been raised for this job. The admin will address the issue shortly.",
	},
	ISSUE_RESOLVED: {
		TASKER: "The issue has been resolved. Thank you for your patience.",
		USER: "The issue has been resolved. Thank you for your patience.",
	},
};

// INFO: offers states
export const offerStatus = {
	PENDING: "PENDING",
	ACCEPTED: "ACCEPTED",
	DECLINED: "DECLINED",
	CANCELLED: "CANCELLED",
};

// INFO: message types
export const messageTypes = {
	OFFER: "OFFER",
	OFFER_ACTION: "OFFER_ACTION",
	TEXT: "TEXT",
};

// INFO: offer action messages
export const offerActionMessages = {
	ACCEPTED: "Offer has been accepted",
	DECLINED: "Offer has been declined",
};

export const orderStatusForDropdown = [
	{ label: "Order In Progress", id: "ORDER_IN_PROGRESS" },
	{ label: "Delivered", id: "ORDER_DELIVERED" },
	{ label: "Completed", id: "COMPLETED" },
	{ label: "Complaint Raised", id: "COMPLAINT_RAISED" },
	{ label: "Resolved", id: "COMPLAINT_RESOLVED" },
	{ label: "In Revision", id: "IN_REVISION" },
	{ label: "Issue Raised", id: "ISSUE_RAISED" },
	{ label: "Issue Resolved", id: "ISSUE_RESOLVED" },
];

export const referencesFormats = {
	JPEG_JPG: { mime: "image/jpeg", extensions: [".jpeg", ".jpg"] },
	PNG: { mime: "image/png", extensions: [".png"] },
	PDF: { mime: "application/pdf", extensions: [".pdf"] },
	DOC: { mime: "application/msword", extensions: [".doc"] },
	DOCX: {
		mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
		extensions: [".docx"],
	},
	XLSX: {
		mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		extensions: [".xlsx"],
	},
	PPTX: {
		mime: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
		extensions: [".pptx"],
	},
	CSV: { mime: "text/csv", extensions: [".csv"] },
	TXT: { mime: "text/plain", extensions: [".txt"] },
	ZIP: { mime: "application/zip", extensions: [".zip"] },
	RAR: { mime: "application/vnd.rar", extensions: [".rar"] },
};

export const maximumImagesUploadingSizes = {
	size_300KB: 0.3, // 300KB
	size_450KB: 0.45, // 300KB
	size_1MB: 1, // 300KB
};

export const cities = [
	{
		_id: "1",
		name: "Accra",
		subcities: [
			{ _id: "11", name: "Adenta" },
			{ _id: "12", name: "Madina" },
			{ _id: "13", name: "Tema" },
			{ _id: "14", name: "Teshie" },
			{ _id: "15", name: "Nungua" },
			{ _id: "16", name: "Ashaiman" },
			{ _id: "17", name: "Dansoman" },
			{ _id: "18", name: "Spintex" },
			{ _id: "19", name: "Osu" },
			{ _id: "110", name: "East Legon" },
		],
	},
	{
		_id: "2",
		name: "Kumasi",
		subcities: [
			{ _id: "21", name: "Bantama" },
			{ _id: "22", name: "Suame" },
			{ _id: "23", name: "Oforikrom" },
			{ _id: "24", name: "Asokwa" },
			{ _id: "25", name: "Kwadaso" },
			{ _id: "26", name: "Ejisu" },
			{ _id: "27", name: "Manhyia" },
		],
	},
	{
		_id: "3",
		name: "Sekondi-Takoradi",
		subcities: [
			{ _id: "31", name: "Effia" },
			{ _id: "32", name: "Kwesimintsim" },
			{ _id: "33", name: "Shama" },
			{ _id: "34", name: "Agona Nkwanta" },
		],
	},
	{
		_id: "4",
		name: "Cape Coast",
		subcities: [
			{ _id: "41", name: "Elmina" },
			{ _id: "42", name: "Mankessim" },
			{ _id: "43", name: "Kasoa" },
			{ _id: "44", name: "Saltpond" },
		],
	},
	{
		_id: "5",
		name: "Koforidua",
		subcities: [
			{ _id: "51", name: "New Juaben" },
			{ _id: "52", name: "Nsawam" },
			{ _id: "53", name: "Aburi" },
			{ _id: "54", name: "Suhum" },
		],
	},
	{
		_id: "6",
		name: "Tamale",
		subcities: [
			{ _id: "61", name: "Sagnarigu" },
			{ _id: "62", name: "Yendi" },
			{ _id: "63", name: "Savelugu" },
		],
	},
	{
		_id: "7",
		name: "Ho",
		subcities: [
			{ _id: "71", name: "Keta" },
			{ _id: "72", name: "Hohoe" },
			{ _id: "73", name: "Aflao" },
		],
	},
	{
		_id: "8",
		name: "Bolgatanga",
		subcities: [
			{ _id: "81", name: "Bawku" },
			{ _id: "82", name: "Navrongo" },
		],
	},
	{
		_id: "9",
		name: "Wa",
		subcities: [
			{ _id: "91", name: "Nadowli" },
			{ _id: "92", name: "Tumu" },
		],
	},
	{
		_id: "10",
		name: "Sunyani",
		subcities: [
			{ _id: "101", name: "Berekum" },
			{ _id: "102", name: "Dormaa Ahenkro" },
		],
	},
	{
		_id: "11",
		name: "Goaso",
		subcities: [
			{ _id: "111", name: "Hwidiem" },
			{ _id: "112", name: "Mim" },
		],
	},
	{
		_id: "12",
		name: "Techiman",
		subcities: [
			{ _id: "121", name: "Kintampo" },
			{ _id: "122", name: "Nkoranza" },
		],
	},
	{
		_id: "13",
		name: "Damongo",
		subcities: [
			{ _id: "131", name: "Bole" },
			{ _id: "132", name: "Salaga" },
		],
	},
	{
		_id: "14",
		name: "Nalerigu",
		subcities: [
			{ _id: "141", name: "Walewale" },
			{ _id: "142", name: "Gambaga" },
		],
	},
	{
		_id: "15",
		name: "Sefwi Wiawso",
		subcities: [
			{ _id: "151", name: "Bibiani" },
			{ _id: "152", name: "Enchi" },
		],
	},
	{
		_id: "16",
		name: "Dambai",
		subcities: [
			{ _id: "161", name: "Kete Krachi" },
			{ _id: "162", name: "Nkwanta" },
		],
	},
];

// INFO: Paystack Mobile Money Providers in Ghana
export const mobileMoneyProviders = [
	{
		_id: "mtn",
		name: "MTN Mobile Money (MTN MoMo)",
	},
	{
		_id: "atl",
		name: "AirtelTigo Money",
	},
	{
		_id: "vod",
		name: "Vodafone Cash",
	},
];

// INFO: Ghana Banks
export const banks = [
	{ _id: "1", name: "GCB Bank" },
	{ _id: "2", name: "Absa Bank Ghana" },
	{ _id: "3", name: "Stanbic Bank Ghana" },
	{ _id: "4", name: "Ecobank Ghana" },
	{ _id: "5", name: "Fidelity Bank Ghana" },
	{ _id: "6", name: "CalBank" },
	{ _id: "7", name: "Zenith Bank Ghana" },
	{ _id: "8", name: "Access Bank Ghana" },
	{ _id: "9", name: "Republic Bank Ghana" },
	{ _id: "10", name: "First National Bank Ghana" },
	{ _id: "11", name: "United Bank for Africa (UBA) Ghana" },
	{ _id: "12", name: "Societe Generale Ghana" },
	{ _id: "13", name: "Guaranty Trust Bank (GTBank) Ghana" },
	{ _id: "14", name: "Standard Chartered Bank Ghana" },
	{ _id: "15", name: "First Atlantic Bank" },
	{ _id: "16", name: "Consolidated Bank Ghana (CBG)" },
	{ _id: "17", name: "OmniBSIC Bank" },
	{ _id: "18", name: "Universal Merchant Bank (UMB)" },
	{ _id: "19", name: "Prudential Bank" },
	{ _id: "20", name: "National Investment Bank (NIB)" },
];

// INFO: complaint reasons types
export const complaintReasons = [
	{ _id: "1", reason: "Incomplete cleaning" },
	{ _id: "2", reason: "Damaged property" },
	{ _id: "3", reason: "Late arrival" },
	{ _id: "4", reason: "Unprofessional behavior" },
	{ _id: "5", reason: "Plants damaged" },
	{ _id: "6", reason: "Incomplete work" },
	{ _id: "7", reason: "Tools left behind" },
	{ _id: "8", reason: "Overcharged" },
	{ _id: "9", reason: "Leaking pipes after service" },
	{ _id: "10", reason: "Incomplete repair" },
	{ _id: "11", reason: "Wrong part used" },
];

// INFO: complaint resolving reasons types
export const complaintResolvingReasons = [
	{ _id: "1", name: "Incomplete cleaning" },
	{ _id: "2", name: "Damaged property" },
	{ _id: "3", name: "Late arrival" },
	{ _id: "4", name: "Unprofessional behavior" },
	{ _id: "5", name: "Plants damaged" },
	{ _id: "6", name: "Incomplete work" },
	{ _id: "7", name: "Tools left behind" },
	{ _id: "8", name: "Overcharged" },
	{ _id: "9", name: "Leaking pipes after service" },
	{ _id: "10", name: "Incomplete repair" },
	{ _id: "11", name: "Wrong part used" },
];

export const paymentTypes = {
	BANK: "BANK",
	MOBILE_MONEY: "MOBILE_MONEY",
};

export const paymentMetrics = {
	taskerCommision: 80, // 80%
	clientFee: 6, // 6%
	boundaryAmount: 200, // GHS
	minimumAmount: 30, // GHS
	flatFee: 20, // GHS
};

export const clientQuestions = [
	{
		question: "How do I post a task?",
		answer: "Simply create an account, click “Post a Job,” describe the task, choose a category, set your location and budget, then submit.",
	},
	{
		question: "How do I choose the right service provider?",
		answer: "You can review tasker profiles, ratings, and reviews before hiring.",
	},
	{
		question: "Can I schedule a task in advance?",
		answer: "Yes! You can choose a future date and time when posting your job.",
	},
	{
		question: "How do I pay for a task?",
		answer: "You’ll pay securely through the app using Mobile Money or card. Payment is held until the job is completed and confirmed.",
	},
	{
		question: "What if the task is not completed properly?",
		answer: "We offer a resolution process where you can dispute the task before payment is released.",
	},
	{
		question: "Are the taskers verified?",
		answer: "Yes. All taskers go through an ID verification process.",
	},
];

export const taskerQuestions = [
	{
		question: "How do I sign up as a tasker?",
		answer: "Go onto the website, select “Sign up as a service Pro,” fill in your profile, choose your skills, and upload your ID for verification.",
	},
	{
		question: "How are taskers verified?",
		answer: "Taskers must submit valid national ID and a selfie which is verified using a third party.",
	},
	{
		question: "How do I find jobs?",
		answer: "Go to the Jobs tab, use the filters (location, category, budget), and apply for jobs you are qualified for.",
	},
	{
		question: "Do I have to pay to get jobs?",
		answer: "No. Jumaconnect is free to use. A small commission is deducted only when you complete a job successfully.",
	},
	{
		question: "Can I set my service area?",
		answer: "Yes! You can choose your suburb or select city if you are willing to travel for jobs.",
	},
	{
		question: "How do I get paid?",
		answer: "Once the job is completed and confirmed by the client, your payment will be processed and sent to your Mobile Money or bank account.",
	},
	{
		question: "Can I decline a job?",
		answer: "Yes. You are free to accept or decline any job that doesn’t suit you.",
	},
	{
		question: "How do I improve my profile?",
		answer: "Complete your profile, add certifications, respond quickly to clients, post photos of completed jobs and complete jobs with a quality finish to earn better ratings and reviews.",
	},
];

export const generalQuestions = [
	{
		question: "What is Jumaconnect?",
		answer: "Jumaconnect is a platform that connects clients with service providers (taskers) across Accra and Ghana for tasks like plumbing, electrical work, cleaning, and many more.",
	},
	{
		question: "Is Jumaconnect free to use?",
		answer: "Yes! Signing up and using the platform is free. Fees are only charged when a job is booked and successfully completed.",
	},
	{
		question: "Which locations do you operate in?",
		answer: "We are currently available in Accra, with plans to expand across Ghana soon.",
	},
	{
		question: "Is payment safe?",
		answer: "Yes. All payments are processed through a secure system and held until the task is completed and confirmed by client.",
	},
	{
		question: "How do I contact support?",
		answer: "You can reach us via WhatsApp live chat, email, or our support form.",
	},
];

export const TAGS = [
	{ name: "Exclusive", color: "#FFD700" },
	{ name: "EastCoast", color: "#6495ED" },
	{ name: "Afrobeats", color: "#32CD32" },
	{ name: "Dance", color: "#FF69B4" },
	{ name: "DownSouth", color: "#B0E0E6" },
	{ name: "Dancehall", color: "#00CED1" },
	{ name: "NewYork", color: "#708090" },
	{ name: "DJTools", color: "#1E90FF" },
	{ name: "ElectroPop", color: "#9370DB" },
	{ name: "FrenchRap", color: "#00FA9A" },
	{ name: "GermanRap", color: "#D2691E" },
	{ name: "Reggeeton", color: "#DC143C" },
	{ name: "WestCoast", color: "#00FFFF" },
	{ name: "Mainstream", color: "#7B68EE" },
	{ name: "House", color: "#98FB98" },
	{ name: "MidWest", color: "#3CB371" },
	{ name: "TechHouse", color: "#DA70D6" },
	{ name: "Atlanta", color: "#FF4500" },
	{ name: "Dembow", color: "#FF0000" },
	{ name: "Dutch", color: "#191970" },
	{ name: "Urbano", color: "#20B2AA" },
	{ name: "UKRap", color: "#2E8B57" },
	{ name: "HipHop", color: "#6A5ACD" },
	{ name: "RnB", color: "#8B0000" },
	{ name: "Moombahton", color: "#8B008B" },
];

export const GENRES_LIST = [
	{
		id: "all",
		name: "All Genres",
		code: "#000000",
	},
	{
		id: "hiphop",
		name: "Hip-Hop",
		code: "#E63946",
	},
	{
		id: "randb",
		name: "R&B",
		code: "#E63946",
	},
	{
		id: "latin",
		name: "Latin",
		code: "#6A0DAD",
	},
	{
		id: "electronic",
		name: "Electronic",
		code: "#007BFF",
	},
	{
		id: "dance",
		name: "Dance",
		code: "#007BFF",
	},
	{
		id: "international",
		name: "International",
		code: "#FFFF00",
	},
	{
		id: "reggae",
		name: "Reggae",
		code: "#32CD32",
	},
	{
		id: "dancehall",
		name: "Dancehall",
		code: "#32CD32",
	},
	{
		id: "pop",
		name: "Pop",
		code: "#FF1493",
	},
	{
		id: "top100",
		name: "Top 100",
		code: "#FF1493",
	},
];

export const verificationStatus = {
	PENDING: "pending",
	APPROVED: "approved",
	REJECTED: "rejected",
};
